module.exports = __webpack_public_path__ + "img/red-packet-bubble.e240bb8d.png";